import get from "lodash/get";
import pick from "lodash/pick";
import { createSelector } from "reselect";

const getInitialAdConfig = (state) =>
  get(state, "story.ads.initial", {
    generateCorrelator: false,
    includeUrl: false,
  });

const getAdNetworkOptions = createSelector(
  getInitialAdConfig,
  (initialAdConfig) =>
    pick(initialAdConfig, ["generateCorrelator", "includeUrl"]),
);

export default getAdNetworkOptions;
